export const AFYA_IMARA_PAYLOAD_COLLECTION = 'afyaImara/collection/';

// API Calls actions
export const API_PENDING_TRANSITION_PAYLOAD_COLLECTION = `${AFYA_IMARA_PAYLOAD_COLLECTION}/apiTransition/pending`;
export const API_SUCCESS_TRANSITION_PAYLOAD_COLLECTION = `${AFYA_IMARA_PAYLOAD_COLLECTION}/apiTransition/success`;
export const API_FAILURE_TRANSITION_PAYLOAD_COLLECTION = `${AFYA_IMARA_PAYLOAD_COLLECTION}/apiTransition/failure`;

export const apiTransitionPayloadCollection = {
    pending: () => ({
        type: API_PENDING_TRANSITION_PAYLOAD_COLLECTION,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_PAYLOAD_COLLECTION,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_PAYLOAD_COLLECTION,
    }),
};

//calculated Data
export const COLLECT_PAYLOAD_DATA = AFYA_IMARA_PAYLOAD_COLLECTION + 'collectPayloadData';
export const COLLECT_ID = AFYA_IMARA_PAYLOAD_COLLECTION + 'collectId';
export const PAYMENT_TYPE = AFYA_IMARA_PAYLOAD_COLLECTION + 'paymentType';
export const SUBMIT_COLLECT_PAYLOAD_SUCCESS = AFYA_IMARA_PAYLOAD_COLLECTION + 'success';
export const SUBMIT_COLLECT_PAYLOAD_FAILURE = AFYA_IMARA_PAYLOAD_COLLECTION + 'failure';

export const collectPayloadData = () => ({
    type: COLLECT_PAYLOAD_DATA,
});
export const collectId = (value) => ({
    type: COLLECT_ID,
    value,
});
export const setPaymentType = (value) => ({
    type: PAYMENT_TYPE,
    value,
});
export const submitPayloadDataSuccess = (value) => ({
    type: SUBMIT_COLLECT_PAYLOAD_SUCCESS,
    value,
});
export const submitPayloadDataFailure = (error) => ({
    type: SUBMIT_COLLECT_PAYLOAD_FAILURE,
    error,
});
